import { useEffect } from "react";
import { useLocation } from "react-router";

function NotFound() {
  const location = useLocation();

  useEffect(() => {
    if (import.meta.env.DEV) {
      console.warn("404 Error: User attempted to access non-existent route:", location.pathname);
    }
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <h1 className="text-6xl font-bold text-primary">404</h1>
        <p className="text-xl text-muted-foreground">Oops! Siden finnes ikke</p>
        <a href="/" className="text-primary underline hover:text-primary/80 inline-block mt-4">
          Tilbake til Dashboard
        </a>
      </div>
    </div>
  );
}

export default NotFound;
